import { api } from "../../../../../../evergis/api";
import { getUrlFromBlob } from "../../../../../../utils/image";

export const getImageSrc = async (isExternal: boolean, link: string): Promise<string> => {
  if (isExternal) {
    return link;
  }

  return getUrlFromBlob(await api.catalog.downloadFile(link));
};
